<template>
  <div>
    <h2 style="font-size: 11px" v-if="text">{{ text }}</h2>
    <HvhSearchBox class="my-1" :text="searchPositionText" v-model="searchWord" @input="findNextSearchItem()" @up="searchUp()" @down="searchDown()" @close="reset" />
  </div>
</template>
  
  <script>
import { isFunction, searchWordRegex } from '../../libraries/common';
import HvhSearchBox from '../common/searchBox/HvhSearchBox.vue';
export default {
  components: { HvhSearchBox },
  props: ['data', 'text', 'prop'],
  data() {
    return {
      scrollBarValue: 0,
      searchWord: null,
      currentSearchItem: null,
    }
  },
  methods: {
    findNextSearchItem() {
      this.currentSearchItem = this.foundItems.find(f => this.data.indexOf(f) >= this.scrollBarValue) || this.foundItems[0];
      this.emit();
    },
    searchUp() {
      var nextInd = this.currentSearchItemIndex.found - 1;
      if (nextInd < 0)
        nextInd = this.foundItems.length - 1;
      this.currentSearchItem = this.foundItems[nextInd];
      this.emit();
    },
    searchDown() {
      var nextInd = this.currentSearchItemIndex.found + 1;
      if (nextInd >= this.foundItems.length)
        nextInd = 0;
      this.currentSearchItem = this.foundItems[nextInd];
      this.emit();
    },
    reset() {
      this.searchWord = null;
      this.emit();
      this.$emit('close');
    },
    emit() {
      this.$emit('input', {
        word: this.searchWord,
        regex: this.searchWordRegex,
        index: this.currentSearchItemIndex.data,
        foundItems: this.foundItems,
      });
    },
  },
  computed: {
    propFnc() {
      return isFunction(this.prop) ? this.prop : (f => this.prop ? f[this.prop] : f);
    },
    searchWordRegex() {
      return this.searchWord ? searchWordRegex(this.searchWord) : null;
    },
    foundItems() {
      if (!this.searchWordRegex) return [];
      return this.data.filter(f => this.propFnc(f).match(this.searchWordRegex));
    },
    currentSearchItemIndex() {
      return {
        data: this.data.indexOf(this.currentSearchItem),
        found: this.foundItems.indexOf(this.currentSearchItem)
      };
    },
    searchPositionText() {
      return `${this.currentSearchItemIndex.found + 1}/${this.foundItems.length}`;
    },
  },
}
</script>
